var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroframe2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1282,
    height: 761,
    viewBox: "0 0 1282 761",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_85_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.134 740.894L1162.64 740.894C1162.64 671.809 1208.01 615.883 1264.06 615.883L1264.06 475.739",
    stroke: "url(#paint0_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.18 440.538L1246.18 696.482C1246.18 708.983 1237.9 718.852 1228.03 718.852L742.019 718.852L725.205 739.577",
    stroke: "url(#paint1_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 740.893L1226.96 695.166L1263.79 695.166C1263.79 720.168 1247.24 740.893 1226.96 740.893Z",
    stroke: "url(#paint2_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 695.166L1226.96 509.952",
    stroke: "url(#paint3_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 695.166L831.961 695.166L795.664 740.235",
    stroke: "url(#paint4_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 695.165L1192.26 652.398",
    stroke: "url(#paint5_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 695.166L1209.61 635.292",
    stroke: "url(#paint6_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 695.166L1178.39 673.782",
    stroke: "url(#paint7_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.134 20.4356L1162.64 20.4356C1162.64 89.5206 1208.01 145.447 1264.06 145.447L1264.06 285.59",
    stroke: "url(#paint8_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.18 320.462L1246.18 64.5184C1246.18 52.0173 1237.9 42.148 1228.03 42.148L742.019 42.148L724.404 20.4356",
    stroke: "url(#paint9_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 20.4356L1226.96 66.1633L1263.79 66.1633C1263.79 40.8321 1247.24 20.4356 1226.96 20.4356Z",
    stroke: "url(#paint10_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 65.834L1226.96 251.048",
    stroke: "url(#paint11_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 65.8343L831.961 65.8343L795.397 20.4356",
    stroke: "url(#paint12_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 65.834L1192.26 108.601",
    stroke: "url(#paint13_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 65.834L1209.61 125.708",
    stroke: "url(#paint14_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.96 65.834L1178.39 87.2175",
    stroke: "url(#paint15_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246 453.836C1237.33 453.836 1230 446.835 1230 437.836C1230 429.169 1237 421.836 1246 421.836C1254.67 421.836 1262 428.836 1262 437.836C1261.67 446.835 1254.67 453.836 1246 453.836Z",
    stroke: "url(#paint16_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.09 432.299C1239.98 441.085 1255.1 440.154 1263.85 430.219C1272.6 420.283 1271.67 405.106 1261.78 396.319C1251.88 387.532 1236.77 388.463 1228.01 398.399C1219.26 408.334 1220.19 423.512 1230.09 432.299Z",
    stroke: "url(#paint17_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246 337.836C1237.33 337.836 1230 331.054 1230 322.335C1230 313.94 1237 306.836 1246 306.836C1254.67 306.836 1262 313.617 1262 322.335C1261.67 331.054 1254.67 337.836 1246 337.836Z",
    stroke: "url(#paint18_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.91 363.225C1238.25 372.604 1253.4 372.604 1262.74 363.225C1272.08 353.847 1272.08 338.641 1262.74 329.263C1253.4 319.885 1238.25 319.885 1228.91 329.263C1219.57 338.641 1219.57 353.847 1228.91 363.225Z",
    stroke: "url(#paint19_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212 380.836C1212 399.613 1227.22 414.836 1246 414.836C1264.78 414.836 1280 399.613 1280 380.836C1280 362.058 1264.78 346.836 1246 346.836C1227.22 346.836 1212 362.058 1212 380.836Z",
    stroke: "url(#paint20_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.92 65.834L1253.92 251.048L1219.75 293.157L1219.75 322.435",
    stroke: "url(#paint21_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.92 695.165L1253.92 509.952L1219.75 467.843L1219.75 438.564",
    stroke: "url(#paint22_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.69 31.2916L959.268 31.2916L941.386 53.333L701.184 53.3329L675.029 21.0933",
    stroke: "url(#paint23_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.69 730.366L959.268 730.366L941.386 708.324L701.184 708.324L675.029 740.893",
    stroke: "url(#paint24_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3069 729.708L322.732 729.708L340.614 707.667L580.816 707.667L606.971 739.906",
    stroke: "url(#paint25_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.133 20.4356L119.628 20.4356C119.628 89.5206 74.2565 145.446 18.2094 145.446L18.2093 285.59",
    stroke: "url(#paint26_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8241 320.462L35.8241 64.5183C35.8241 52.0172 44.0977 42.1479 53.9727 42.1479L540.248 42.1479L557.063 21.4224",
    stroke: "url(#paint27_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0401 20.4356L55.0401 66.1633L17.9422 66.1633C18.2091 40.8321 34.7563 20.4356 55.0401 20.4356Z",
    stroke: "url(#paint28_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0401 65.834L55.0401 251.048",
    stroke: "url(#paint29_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0405 65.8344L450.039 65.8344L486.604 20.7647",
    stroke: "url(#paint30_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.04 65.834L89.7359 108.601",
    stroke: "url(#paint31_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.04 65.834L72.388 125.708",
    stroke: "url(#paint32_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0406 65.834L103.615 87.2175",
    stroke: "url(#paint33_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.824 440.538L35.824 696.482C35.824 708.983 44.0976 718.852 53.9726 718.852L540.248 718.852L557.863 740.564",
    stroke: "url(#paint34_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0398 740.893L55.0398 695.166L17.942 695.166C18.2089 720.168 34.7561 740.893 55.0398 740.893Z",
    stroke: "url(#paint35_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0398 695.166L55.0398 509.952",
    stroke: "url(#paint36_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9998 695L450.069 695L487 741",
    stroke: "url(#paint37_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0398 695.166L89.7356 652.399",
    stroke: "url(#paint38_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0398 695.166L72.3877 635.292",
    stroke: "url(#paint39_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0403 695.166L103.615 673.782",
    stroke: "url(#paint40_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.133 740.894L119.628 740.894C119.628 671.809 74.2563 615.883 18.2091 615.883L18.2091 475.739",
    stroke: "url(#paint41_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8243 454.165C27.1576 454.165 19.8243 447.165 19.8243 438.165C19.8243 429.498 26.8243 422.165 35.8243 422.165C44.4909 422.165 51.8243 429.165 51.8243 438.165C51.4909 447.165 44.4909 454.165 35.8243 454.165Z",
    stroke: "url(#paint42_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9101 432.628C29.8053 441.415 44.9212 440.483 53.6725 430.548C62.4237 420.612 61.4964 405.435 51.6012 396.648C41.706 387.861 26.5901 388.792 17.8388 398.728C9.08753 408.663 10.0149 423.841 19.9101 432.628Z",
    stroke: "url(#paint43_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8243 338.165C27.1576 338.165 19.8243 331.383 19.8243 322.665C19.8243 314.269 26.8243 307.165 35.8243 307.165C44.4909 307.165 51.8243 313.946 51.8243 322.665C51.4909 331.383 44.4909 338.165 35.8243 338.165Z",
    stroke: "url(#paint44_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7367 363.554C28.0771 372.933 43.2208 372.933 52.5612 363.554C61.9016 354.176 61.9017 338.971 52.5613 329.592C43.2209 320.214 28.0771 320.214 18.7367 329.592C9.39627 338.971 9.39627 354.176 18.7367 363.554Z",
    stroke: "url(#paint45_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82449 381.165C1.82449 399.942 17.0468 415.165 35.8245 415.165C54.6022 415.165 69.8245 399.942 69.8245 381.165C69.8245 362.387 54.6022 347.165 35.8245 347.165C17.0468 347.165 1.8245 362.387 1.82449 381.165Z",
    stroke: "url(#paint46_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0847 695.165L28.0847 509.952L62.2469 467.843L62.2469 438.564",
    stroke: "url(#paint47_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0847 65.834L28.0847 251.048L62.2468 293.157L62.2468 322.435",
    stroke: "url(#paint48_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3069 30.6338L322.732 30.6338L340.614 52.6752L580.816 52.6753L606.971 20.4356",
    stroke: "url(#paint49_linear_85_2)",
    strokeWidth: 1.64488,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.5 36.1578C633.104 36.1578 626 29.1578 626 20.1578C626 11.4911 632.781 4.15777 641.5 4.15777C649.896 4.15777 657 11.1578 657 20.1578C657 29.1578 649.896 36.1578 641.5 36.1578Z",
    stroke: "url(#paint50_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641 756.158C631.792 756.158 624 749.377 624 740.658C624 732.262 631.438 725.158 641 725.158C650.208 725.158 658 731.939 658 740.658C658 749.377 650.208 756.158 641 756.158Z",
    stroke: "url(#paint51_linear_85_2)",
    strokeWidth: 3.28976,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_2",
    x1: 1264.06,
    y1: 608.316,
    x2: 641.134,
    y2: 608.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_2",
    x1: 1246.18,
    y1: 590.058,
    x2: 725.205,
    y2: 590.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_85_2",
    x1: 1263.79,
    y1: 718.029,
    x2: 1226.96,
    y2: 718.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_2",
    x1: 1226.96,
    y1: 602.559,
    x2: 1225.96,
    y2: 602.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_85_2",
    x1: 1226.96,
    y1: 717.7,
    x2: 795.664,
    y2: 717.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_85_2",
    x1: 1226.96,
    y1: 673.782,
    x2: 1192.26,
    y2: 673.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_85_2",
    x1: 1226.96,
    y1: 665.229,
    x2: 1209.61,
    y2: 665.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_85_2",
    x1: 1226.96,
    y1: 684.474,
    x2: 1178.39,
    y2: 684.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_85_2",
    x1: 1264.06,
    y1: 153.013,
    x2: 641.134,
    y2: 153.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_85_2",
    x1: 1246.18,
    y1: 170.449,
    x2: 724.404,
    y2: 170.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_85_2",
    x1: 1263.79,
    y1: 43.2994,
    x2: 1226.96,
    y2: 43.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_85_2",
    x1: 1226.96,
    y1: 158.441,
    x2: 1225.96,
    y2: 158.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_85_2",
    x1: 1226.96,
    y1: 43.135,
    x2: 795.397,
    y2: 43.1349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_85_2",
    x1: 1226.96,
    y1: 87.2175,
    x2: 1192.26,
    y2: 87.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_85_2",
    x1: 1226.96,
    y1: 95.7709,
    x2: 1209.61,
    y2: 95.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_85_2",
    x1: 1226.96,
    y1: 76.5258,
    x2: 1178.39,
    y2: 76.5258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_85_2",
    x1: 1262,
    y1: 437.836,
    x2: 1230,
    y2: 437.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_85_2",
    x1: 1261.78,
    y1: 396.319,
    x2: 1229.94,
    y2: 432.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_85_2",
    x1: 1262,
    y1: 322.336,
    x2: 1230,
    y2: 322.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_85_2",
    x1: 1262.74,
    y1: 329.263,
    x2: 1228.77,
    y2: 363.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_85_2",
    x1: 1280,
    y1: 380.836,
    x2: 1212,
    y2: 380.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_85_2",
    x1: 1253.92,
    y1: 194.135,
    x2: 1219.75,
    y2: 194.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_85_2",
    x1: 1253.92,
    y1: 566.865,
    x2: 1219.75,
    y2: 566.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_85_2",
    x1: 1226.69,
    y1: 37.2131,
    x2: 675.029,
    y2: 37.2131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_85_2",
    x1: 1226.69,
    y1: 724.609,
    x2: 675.029,
    y2: 724.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_85_2",
    x1: 606.971,
    y1: 723.786,
    x2: 55.3069,
    y2: 723.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_85_2",
    x1: 641.133,
    y1: 153.013,
    x2: 18.2094,
    y2: 153.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_85_2",
    x1: 557.063,
    y1: 170.942,
    x2: 35.8241,
    y2: 170.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_85_2",
    x1: 55.0401,
    y1: 43.2994,
    x2: 17.9422,
    y2: 43.2994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_85_2",
    x1: 55.0401,
    y1: 158.441,
    x2: 54.0401,
    y2: 158.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_85_2",
    x1: 486.604,
    y1: 43.2996,
    x2: 55.0405,
    y2: 43.2995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_85_2",
    x1: 89.7359,
    y1: 87.2175,
    x2: 55.04,
    y2: 87.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_85_2",
    x1: 72.388,
    y1: 95.7709,
    x2: 55.04,
    y2: 95.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_85_2",
    x1: 103.615,
    y1: 76.5258,
    x2: 55.0406,
    y2: 76.5258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_85_2",
    x1: 557.863,
    y1: 590.551,
    x2: 35.824,
    y2: 590.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_85_2",
    x1: 55.0398,
    y1: 718.029,
    x2: 17.942,
    y2: 718.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_85_2",
    x1: 55.0398,
    y1: 602.559,
    x2: 54.0398,
    y2: 602.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_85_2",
    x1: 487,
    y1: 718,
    x2: 53.9998,
    y2: 718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_85_2",
    x1: 89.7356,
    y1: 673.782,
    x2: 55.0398,
    y2: 673.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_85_2",
    x1: 72.3877,
    y1: 665.229,
    x2: 55.0398,
    y2: 665.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_85_2",
    x1: 103.615,
    y1: 684.474,
    x2: 55.0403,
    y2: 684.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_85_2",
    x1: 641.133,
    y1: 608.316,
    x2: 18.2091,
    y2: 608.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_85_2",
    x1: 51.8243,
    y1: 438.165,
    x2: 19.8243,
    y2: 438.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_85_2",
    x1: 51.6012,
    y1: 396.648,
    x2: 19.7654,
    y2: 432.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_85_2",
    x1: 51.8243,
    y1: 322.665,
    x2: 19.8243,
    y2: 322.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_85_2",
    x1: 52.5612,
    y1: 329.592,
    x2: 18.5992,
    y2: 363.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_85_2",
    x1: 69.8245,
    y1: 381.165,
    x2: 1.82449,
    y2: 381.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_85_2",
    x1: 62.2469,
    y1: 566.865,
    x2: 28.0847,
    y2: 566.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_85_2",
    x1: 62.2469,
    y1: 194.135,
    x2: 28.0847,
    y2: 194.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_85_2",
    x1: 606.971,
    y1: 36.5554,
    x2: 55.3069,
    y2: 36.5554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_85_2",
    x1: 657,
    y1: 20.1578,
    x2: 626,
    y2: 20.1578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_85_2",
    x1: 658,
    y1: 740.658,
    x2: 624,
    y2: 740.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDBD79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#876C45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_85_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 761,
    height: 1282,
    fill: "white",
    transform: "translate(1282 5.6038e-05) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroframe2);
export default __webpack_public_path__ + "static/media/heroframe2.7bf2c95e71620c34c2af3404dd4cd4bd.svg";
export { ForwardRef as ReactComponent };